import { Article } from "../../support.types";
import { useSupportSheet } from "../../hooks/useSupportSheet";
import { SupportArticleList } from "./SupportArticleList";

type Props = {
  title: string;
  articles: Article[];
};

export function SupportArticleListContainer({ title, articles }: Props) {
  const { openSheet } = useSupportSheet();

  const handleOpenArticle = (article: Article) => {
    openSheet(article.slug);
  };

  return (
    <SupportArticleList
      title={title}
      articles={articles || []}
      onOpenArticle={handleOpenArticle}
    />
  );
}

export default SupportArticleList;
